import AsyncStorage from "@react-native-community/async-storage";
import React, { useEffect } from "react";
import {
  Dimensions,
  ImageBackground,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";

import globalstyle from "../../Styles/Globals/globals";
import Menu from "../menu";
import style from "../../Styles/premi";
import ReactMarkdown from "react-markdown";
import { getRecursText, getRecursURL } from "../../Functions/getRecurs";
import PremiMultimedia from "./PremiMultimedia";

function Premi(RouterData) {
  const { poi, projecte, itinerari, recursos, idioma, currentItinerari } =
    RouterData.route.params;

  const poiData = itinerari.pois.find((e) => e.id === poi.id);
  const currentPremi = projecte.premis.find((e) => e.id === poiData.premi);
  const currentPoi = currentItinerari.pois.find((e) => e.id === poi.id);

  useEffect(() => {
    if (currentPoi.isLast) {
      currentItinerari.finalitzat = true;
    }
    currentPoi.done = true;
    currentItinerari.puntsTotals =
      parseInt(currentItinerari.puntsTotals) + parseInt(currentPoi.punts);
    currentItinerari.currentOrder = currentItinerari.currentOrder + 1;

    AsyncStorage.setItem(
      "itinerari" + itinerari.id,
      JSON.stringify(currentItinerari),
    );

    AsyncStorage.getItem("puntsTotals").then((punts) => {
      if (punts == null) {
        AsyncStorage.setItem(
          "puntsTotals",
          currentItinerari.puntsTotals.toString(),
        );
      } else {
        AsyncStorage.setItem(
          "puntsTotals",
          (parseInt(punts) + parseInt(currentPoi.punts)).toString(),
        );
      }
    });
  }, []);

  const saltarTrucada = () => {
    RouterData.navigation.navigate("PreviTrucada", RouterData.route.params);
  };

  {
    /* Es fa servir amb projectes sense cenobify (per google analytics) */
  }
  const sendToAnalitycs = async () => {
    Analytics.logEvent(
      "Posta_" + this.state.currentStateItinerari.currentOrder,
      {
        screen: "Posta_" + this.state.currentStateItinerari.currentOrder,
        purpose:
          "Ha acabat el premi " + this.state.currentStateItinerari.currentOrder,
      },
    );
  };

  return (
    <View
      style={{
        flex: 1,
        width: "100%",
        height: "100%",
        maxHeight: Dimensions.get("screen").height,
        maxWidth: "100%",
      }}
    >
      <ImageBackground
        source={{
          uri: getRecursURL(recursos, "background_default", idioma),
        }}
        style={{ flex: 1 }}
      >
        {/* Bocata has guanyat/puntuacio */}
        <View
          style={{ flex: 20, justifyContent: "center", alignItems: "center" }}
        >
          {/*<Text*/}
          {/*  style={{*/}
          {/*    color: "#403d27",*/}
          {/*    fontSize: "2vh",*/}
          {/*    fontWeight: "bold",*/}
          {/*    textAlign: "center",*/}
          {/*    width: "70%",*/}
          {/*    fontFamily: "Gothic",*/}
          {/*  }}*/}
          {/*>*/}
          {/*  {currentPremi["Nom" + idioma]}*/}
          {/*</Text>*/}
          <ImageBackground
            source={{
              uri: getRecursURL(recursos, "bocata_premi", idioma),
            }}
            style={{
              flex: 1,
              width: "100%",
              alignItems: "center",
              alignSelf: "center",
              justifyContent: "center",
              height: "100%",
            }}
            resizeMode={"contain"}
          >
            <View
              style={{
                alignItems: "center",
                alignSelf: "center",
                justifyContent: "center",
                paddingTop: 6,
              }}
            >
              <Text style={style.textPremi}>
                {getRecursText(recursos, "guanyar", idioma)}
              </Text>
              <Text style={style.punts}>
                {currentPoi.punts}/{currentPremi.punts || 100}
              </Text>
              <Text style={style.textPremi}>
                {getRecursText(recursos, "total_itinerari", idioma)}
              </Text>
              <Text style={style.punts}>
                {currentItinerari.puntsTotals + currentPoi.punts}/
                {currentItinerari.puntsItinerari}
              </Text>
            </View>
          </ImageBackground>
        </View>

        {/* Image iframe */}
        <View style={{ flex: 2.5 }}>
          <Text style={style.punts}>{currentPremi["Nom" + idioma]}</Text>
        </View>
        <View
          style={{
            flex: 35,
            justifyContent: "center",
            width: "80%",
            height: "70%",
            alignSelf: "center",
          }}
        >
          {PremiMultimedia(currentPremi)}
        </View>
        {/* Text */}
        <View style={{ flex: 2.5 }} />
        <View style={[{ flex: 20, alignItems: "center" }]}>
          <ScrollView style={{ flexGrow: 1, width: "90%", height: "100%" }}>
            <View
              style={[
                style.descriptionContainer,
                { flexGrow: 1, width: "100%", height: "100%" },
              ]}
            >
              <ReactMarkdown>
                {currentPremi["descripcioPremiDetallat" + idioma]}
              </ReactMarkdown>
            </View>
          </ScrollView>
        </View>

        {/* Boto continuar */}
        <View style={{ flex: 10, justifyContent: "center" }}>
          <TouchableOpacity
            onPress={() => {
              if (currentPoi.isLast) {
                saltarTrucada();
              } else {
                RouterData.navigation.navigate("Mapa", RouterData.route.params);
              }
            }}
          >
            <Text style={globalstyle.botoContinuar}>
              {getRecursText(recursos, "text_continuar", idioma)}
            </Text>
          </TouchableOpacity>
        </View>

        {/* Menu */}
        <View style={{ flex: 10 }}><Menu projecte={RouterData.route.params}></Menu></View>
      </ImageBackground>
    </View>
  );
}

export default Premi;
